__webpack_require__.p = "/skillm/bot/";